$(function () {
  const tab = $('.block-tabs__tab');
  const tabButton = $('.block-tabs__nav-link');

  tabButton.on('click', function (event) {
    event.preventDefault();
    let tabId = $(this).attr('href');
    tabButton.removeClass('active');
    tab.removeClass('active');
    $(this).toggleClass('active');
    $(tabId).toggleClass('active');
  });
});
